import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBars,
    faCalendarPlus,
    faCalendarCheck,
    faChartBar,
    faChartPie,
    faClock,
    faCog,
    faDotCircle,
    faDownload,
    faExclamationCircle,
    faExternalLinkAlt,
    faList,
    faPhoneAlt,
    faPhoneVolume,
    faPlay,
    faPlus,
    faSave,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faTimesCircle,
    faTh,
    faThLarge,
    faThList,
    faUser,
    faUserCog,
    faUsersCog,
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBars,
    faCalendarPlus,
    faCalendarCheck,
    faChartBar,
    faChartPie,
    faClock,
    faCog,
    faDotCircle,
    faDownload,
    faExclamationCircle,
    faExternalLinkAlt,
    faList,
    faPhoneAlt,
    faPhoneVolume,
    faPlay,
    faPlus,
    faSave,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faTimesCircle,
    faTh,
    faThLarge,
    faThList,
    faUser,
    faUserCog,
    faUsersCog,
);

// Register icon component
Vue.component('fa-icon', FontAwesomeIcon);
